import api from './axios';

export async function get_all_beneficiaries(page = 1, searchTerm = '', searchKeyType = '', checkDate = '', welfareFormFilter = '') {
    try {
        let res = await api.get('/beneficiaries/', {
            params: { page, searchTerm, searchKeyType, checkDate, welfareFormFilter }
        });
        res = res.data;
        return res;
    } catch (err) {
        throw err;
    }
}

export async function get_beneficiary_by_id(beneficiary_id) {
    try {
        let res = await api.get(`/beneficiaries/${beneficiary_id}`);
        res = res.data;
        return res;
    }
    catch (err) {
        throw err;
    }
}

export async function add_beneficiary(beneficiary) {
    try {
        let res = await api.post('/beneficiaries/add', beneficiary);
        res = res.data;
        return res;
    }
    catch (err) {
        console.log(err);
        if (err.response) {
            throw {
                message: err.response.data.error,
                status: err.response.status
            };
        }
        throw { message: "Unknown error", status: 500 };
    }
}

export async function update_beneficiary(beneficiary) {
    try {
        const res = await api.put(`/beneficiaries/update/${beneficiary.id}`, beneficiary);
        console.log("update beneficiary", res.data);

        return res.data;
    } catch (err) {
        throw err;
    }
}


export async function delete_beneficiary(beneficiary_id) {
    try {
        const res = await api.delete(`/beneficiaries/delete/${beneficiary_id}`);
        return res.data;
    } catch (err) {
        throw err;
    }
}
